// extracted by mini-css-extract-plugin
export default {"Footer__hr":"footer_Footer__hr__A+agu","Footer__copyright":"footer_Footer__copyright__Y7f1d","Footer__copyright_link":"footer_Footer__copyright_link__CgUG3"};